<template>
	<layout>
		<permissions :id="id"></permissions>
	</layout>
</template>

<script>
	import layout from '../layout/layout.vue'
	import permissions from '../components/permissions.vue'
	export default {
		name: 'permission',
		
		props:{
			id:{
				required: false,
				default: false
			},
		},
		components:{
			layout,
			permissions,
		},
		
		data () {
			return {

			}
		}
	}
</script>

<style lang="css" scoped>
</style>